module.exports = __webpack_public_path__ + "static/media/pests_many.4eeb2854.png";